import React from 'react';
import {Spin} from 'antd';
import './style.css';

const PageLoader = () => (
  <div className='page-loader'>
    <Spin size='large' />
  </div>
);

export default PageLoader;
